import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';
import { Translatable }    from '@widesk-core/decorators/translatable';

@doc.urnResource('event_type')
@doc.path('/event_types/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
@doc.translatable({ description: true, title: true })
abstract class AbstractEventTypeModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_EventTypeReference;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		reference: string;
		createdAt: string;
		updatedAt: string;
		position: string;
	};

	@doc.string declare reference: Website_EventTypeReference;
	@doc.number declare position: number;
	@doc.string declare color: string;
	@doc.string declare textColor: string;
}

interface AbstractEventTypeModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable,
		Translatable<{ description: true, title: true }> {}

export default AbstractEventTypeModel;
